var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn tag-trigger-button",on:{"click":function($event){return _vm.$emit('showTagPopup')}}},[_vm._v("test")])}
var staticRenderFns = []

export { render, staticRenderFns }